import * as Cookies from 'js-cookie';
var cookieStorageHandler = {
    set: function (key, value, options) {
        Cookies.set(key, value, options);
    },
    get: function (key) {
        return Cookies.get(key);
    },
};
export default cookieStorageHandler;
//# sourceMappingURL=cookieStorageHandler.js.map